<template>
  <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    <!-- Sidebar Toggle (Topbar) -->
    <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
      <i class="fa fa-bars"></i>
    </button>

    <!-- Topbar Navbar -->
    <ul class="navbar-nav ml-auto">

      <!-- Nav Item - Alerts -->
      <li class="nav-item dropdown no-arrow mx-1">
        <a class="nav-link dropdown-toggle " href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" @click="show_notification">
          <i class="fas fa-bell fa-fw"></i>
          <!-- Counter - Alerts -->
          <span class="badge badge-danger badge-counter" v-show="new_notification > 0">{{ new_notification }}</span>
        </a>
        <!-- Dropdown - Alerts -->
        <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" :class="{'show': is_show_notification}" aria-labelledby="alertsDropdown">
          <h6 class="dropdown-header">
            Notification
          </h6>
          <div v-if="arr_notification.length > 0">
            <a v-for="(data, index) in arr_notification" :key="'notification_'+index" class="dropdown-item d-flex align-items-center" href="#">
              <div>
                <div class="small text-gray-500">{{ data.created_at_data.format('DD MMMM YYYY') }}</div>
                {{ data.message }}
              </div>
            </a>
          </div>
          <div v-else>
            <a class="dropdown-item text-center small text-gray-500" href="#">No Data Found</a>
          </div>
        </div>
      </li>

      <div class="topbar-divider d-none d-sm-block"></div>

      <!-- Nav Item - User Information -->
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span class="mr-2 d-none d-lg-inline text-gray-600 small"></span>
          <img class="img-profile rounded-circle" src="#">
        </a>
        <!-- Dropdown - User Information -->
        <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
          <a class="dropdown-item" href="/change-password">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Change Password
          </a>
          <a class="dropdown-item" href="#!" data-toggle="modal" data-target="#logoutModal" @click="logout">
            <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
            Logout
          </a>
        </div>
      </li>

    </ul>

  </nav>
</template>

<script>
export default{
  data(){
    return{
      is_show_notification: false,
      arr_notification: [],
      new_notification: 0,
    }
  },
  created(){
    this.get_notification_data()
    this.check_new_notification()
  },
  methods: {
    logout(){
      localStorage.removeItem('token')
      location.href = "/auth/login"
    },
    show_notification(){
      this.is_show_notification = !this.is_show_notification
      if(this.new_notification > 0 && this.is_show_notification)
        this.set_read_notification()
    },
    async get_notification_data(){
      try{
        var response = await axios.get(base_url+'/notification')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_notification = []
          for(let x in response_data.data.data){
            // console.log(moment(response_data.data.data[x].created_at.replace('T',' ').replace('Z','')))
            response_data.data.data[x].created_at_data = moment(response_data.data.data[x].created_at.replace('T',' ').replace('Z',''))
            this.arr_notification.push(response_data.data.data[x])
          }
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
    async check_new_notification(){
      try{
        var response = await axios.get(base_url+'/notification/check-new')

        var response_data = response.data
        if(response_data.status == "success"){
          this.new_notification = response_data.total_data
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
    async set_read_notification(){
      try{
        var response = await axios.put(base_url+'/notification')

        var response_data = response.data
        if(response_data.status == "success"){
          this.check_new_notification()
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
